<template lang="pug">
  div
    ReturnSelection(
      v-if="stage === 'returnSelection'"
      v-on:setReturnDevice="getReturnDevice"
      v-on:setReturnDrugStorage="getReturnDrugStorage"
    )
    Action(
      v-if="stage === 'confirmAmount'"
      v-on:confirmAmountFinish="confirmAmountFinish"
      :defaultNum="forAction.defaultNum"
      :autoCaculateAmount="false"
      :compType="'Confirm'"
      :defaultPackCount="currentDrugInDevice.pack_count"
      :deviceId="forAction.deviceId"
      :checkNum="forAction.checkNum")
      h5 確認藥盒內數量
    Action(
      v-if="stage === 'action'"
      v-on:setActionData="getThisAmount" 
      :inputReadOnly="true"
      :defaultNum="forAction.defaultNum"
      :deviceId="forAction.deviceId"
      :checkNum="forAction.checkNum"
      :defaultPackCount="amountPayload.packCount"
      :limitPackCount="false"
    )
      h5
        strong
          span(v-if="this.currentDevice.specific_type === 'return_device'") 退至退藥盒
          span(v-else-if="returnToEmptyDeviceId") 退至空藥盒
          span(v-else) 退至原藥盒
  

    Loader(v-if="stage === 'finish'")
</template>

<script>
import Action from '../flowComp/Action';
import ReturnSelection from '../flowComp/ReturnSelection';
import Loader from '../common/Loader';

export default {
  name: '',
  props: ['amountPayload', 'actionProgress', 'returnToEmptyDeviceId', 'actionRecorded'],
  components: {
    Action,
    ReturnSelection,
    Loader,
  },
  computed: {
    currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    currentSystem() {
      return this.$store.getters.currentSystem;
    },
    selectedDrugTotalMax() {
      return this.$store.state.drug.selectedDrugTotalMax;
    },
    selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    externalCmpn() {
      return this.$store.state.externalCmpn;
    },
  },
  data() {
    return {
      stage: '',
      totalAmount: 0, // already return
      DrugStorageQueueID: [], // device queue with same drug
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0,
      },
      emitTimes: 0,
      waitThenFinishAction: false,
      waitThenFinishActionEmitTime: 0,
    };
  },
  created() {
    // check return to a new drugStorage or not.
    if (this.returnToEmptyDeviceId) {
      this.forAction = {
        defaultNum: this.amountPayload.amount, //
        checkNum: this.amountPayload.amount,
        deviceId: this.returnToEmptyDeviceId,
      };
      this.stage = 'action';
    } else {
      // return to original drugstorage
      if (this.currentSystem.settings.return_to_original_cmpn) {
        // make sure this system has space for the return amount.
        if (this.currentDrugInDevice.stock < this.currentDrugInDevice.max_stock) {
          // okay, return to orignal device"s".
          // prepare for the first Action child.
          this.forAction = {
            defaultNum: this.amountPayload.amount, //
            checkNum: this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock,
            deviceId: this.currentDrugInDevice.device.id,
          };
          // if confirm amount first, input currentDrugInDevice first.
          if (this.actionProgress[0] === 'confirmAmount') {
            this.forAction = {
              defaultNum: this.currentDrugInDevice.stock,
              checkNum: this.currentDrugInDevice.max_stock,
              deviceId: this.currentDrugInDevice.device.id,
            };
          }

          this.stage = this.actionProgress[0];
          this.$store.commit('SET_CURRENT_STEP', this.actionProgress[0]);
        } else {
          // this system has no space for the return amount, let user choice where they want to return
          this.stage = 'returnSelection';
        }
      } else {
        // not return to original cmpn, thus let user choose.
        this.stage = 'returnSelection';
      }
    }
  },
  mounted() {
  },
  methods: {
    async confirmAmountFinish() {
      await this.$store.dispatch('updateCurrentDrugInDevice', this.currentDrugInDevice.id);
      this.forAction = {
        defaultNum: this.amountPayload.amount - this.totalAmount, // the remain amount after each action.
        checkNum: this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock, // the empty space in the drugStorage
        deviceId: this.currentDrugInDevice.device.id,
      };
      this.stage = 'next';
      setTimeout(() => {
        this.stage = 'action';
        this.$store.commit('SET_CURRENT_STEP', 'action');
      }, 200);
    },
    getReturnDevice(payload) {
      switch (payload.type) {
        case 'external':
          this.stage = ''; // close return selection view.
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '退至外部藥盒，系統已記錄事件。',
            keepOnTop: true,
          });
          this.$emit('setActionData', { device: payload.deviceId, num: this.amountPayload.amount - this.totalAmount, packCount: 0 });
          this.waitThenFinishAction = true;
          break;
        case 'return':
          this.forAction = {
            checkNum: this.amountPayload.amount - this.totalAmount,
            defaultNum: this.amountPayload.amount - this.totalAmount,
            deviceId: payload.deviceId,
          };
          this.stage = 'action';
          break;
        default:
          console.log(payload, 'payload.type not found.');
      }
    },
    getReturnDrugStorage(payload) {
      // this.actionData.push({ drugStorage: payload.drug_storage });
      if (this.$store.state.generalSetting.check_amount_first) {
        this.forAction = {
          checkNum: this.currentDrugInDevice.max_stock,
          defaultNum: this.currentDrugInDevice.stock,
          deviceId: this.currentDrugInDevice.device.id,
        };
        this.stage = 'confirmAmount';
      } else {
        this.forAction = {
          defaultNum: this.amountPayload.amount - this.totalAmount,
          deviceId: payload.drug_storage.device.id,
          checkNum: payload.drug_storage.max_stock - payload.drug_storage.stock,
        };
        this.stage = 'action';
      }
    },
    getThisAmount(data) { // data: device, num
      console.log(this.emitTimes);
      if (this.emitTimes === 0) { // due to action is watched, thus it will emit serveral times.
        this.totalAmount += data.num;
        this.emitTimes += 1;

        if (data.device === this.externalCmpn.id || data.device === this.currentSystem.return_cmpn || this.returnToEmptyDeviceId) {
          this.$emit('setActionData', data);
        } else {
          // else record the whole drugStorage.
          this.$emit('setActionData', { drugStorage: this.currentDrugInDevice, num: data.num, packCount: data.packCount });
        }

        // not finish return yet;
        if (this.totalAmount < this.amountPayload.amount) {
          // let user choose;
          this.stage = 'returnSelection';
          this.emitTimes = 0;
        } else {
          // if return to external/ return cmpn, record its device id.
          this.waitThenFinishAction = true;
          this.stage = 'finish';
        }
      }
    },
  },
  watch: {
    actionRecorded(val) {
      if (val && this.waitThenFinishAction && this.waitThenFinishActionEmitTime === 0) {
        this.$emit('finishAction');
        this.waitThenFinishActionEmitTime += 1;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// ActionWrap.vue?0b6294de